/* eslint-disable camelcase */
import { AWSIoTProvider } from '@aws-amplify/pubsub/lib/Providers'
import Amplify from 'aws-amplify'
import config from './config'

export const configureAmplify = () => {
  Amplify.configure({
    Auth: {
      // mandatorySignIn: false: required for guest (unauthenticated users) to be able to get S3 objects
      mandatorySignIn: false,
      region: config.cognito.REGION,
      userPoolId: config.cognito.USER_POOL_ID,
      identityPoolId: config.cognito.IDENTITY_POOL_ID,
      userPoolWebClientId: config.cognito.APP_CLIENT_ID
    },
    Analytics: {
      disabled: true
    },
    API: {
      endpoints: [
        {
          name: 'apartments',
          endpoint: config.apiGateway.apartments.URL,
          region: config.apiGateway.apartments.REGION
        },
        {
          name: 'applications',
          endpoint: config.apiGateway.applications.URL,
          region: config.apiGateway.applications.REGION
        },
        {
          name: 'showings',
          endpoint: config.apiGateway.showings.URL,
          region: config.apiGateway.showings.REGION
        },
        {
          name: 'users',
          endpoint: config.apiGateway.users.URL,
          region: config.apiGateway.users.REGION
        },
        {
          name: 'applicantAvailability',
          endpoint: config.apiGateway.applicantAvailability.URL,
          region: config.apiGateway.applicantAvailability.REGION
        },
        {
          name: 'instantRent',
          endpoint: config.apiGateway.instantRent.URL,
          region: config.apiGateway.instantRent.REGION
        }
      ]
    },
    Storage: {
      region: config.s3.transcodedMedia.REGION,
      bucket: config.s3.transcodedMedia.BUCKET,
      identityPoolId: config.cognito.IDENTITY_POOL_ID
    }
  })

  Amplify.addPluggable(
    new AWSIoTProvider({
      aws_pubsub_region: config.iot.aws_pubsub_region,
      aws_pubsub_endpoint: config.iot.aws_pubsub_endpoint
    })
  )
}
